module.exports = __webpack_public_path__ + "static/img/banner-煤矿私有化智能助手.b40e0de9.webp";